module.exports = __webpack_public_path__ + "img/video_cover.07c5f26e.png";